var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InfoItems, InfoItem, TypographyHeading, Stacker, Dialog, DialogContent, DialogHeader, } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function HotelSubBoardDialog(_a) {
    var { exclusions: exclusionsProp, inclusions: inclusionsProp } = _a, other = __rest(_a, ["exclusions", "inclusions"]);
    const { resourceStrings: { WHATINCLUDEDTITLE, EXCLUDEDTEXT, INCLUDEDTEXT }, } = useGlobalContext();
    const inclusions = (inclusionsProp === null || inclusionsProp === void 0 ? void 0 : inclusionsProp.filter((e) => e)) || [];
    const exclusions = (exclusionsProp === null || exclusionsProp === void 0 ? void 0 : exclusionsProp.filter((e) => e)) || [];
    return (React.createElement(Dialog, Object.assign({ size: "s" }, other),
        React.createElement(DialogHeader, { "data-id": "Inclusions-Exclusions-dialog", withCloseButton: true, border: false }, WHATINCLUDEDTITLE),
        React.createElement(DialogContent, null,
            React.createElement(Stacker, { spacing: 5, pt: 4, py: 5 },
                inclusions.length > 0 && (React.createElement("div", null,
                    React.createElement(TypographyHeading, { size: "2xs", component: "h4", mb: 2, bold: true }, INCLUDEDTEXT),
                    React.createElement(InfoItems, { bullets: true }, inclusions.map((item) => (React.createElement(InfoItem, { key: item }, item)))))),
                exclusions.length > 0 && (React.createElement("div", null,
                    React.createElement(TypographyHeading, { size: "2xs", component: "h4", mb: 2, bold: true }, EXCLUDEDTEXT),
                    React.createElement(InfoItems, { bullets: true }, exclusions.map((item) => (React.createElement(InfoItem, { key: item }, item))))))))));
}
